import $http from '../../shared/http';

/**
 * This is a submodule of the organisations module.
 * Reference it from components with "organisations/organisation_preferences"
 */
export const system_settings = {
  namespaced: true,
  state: () => {
    return {
      systemSettings: null,
    };
  },
  getters: {
    getSystemSettings: (state) => state.systemSettings,
  },
  mutations: {
    setSystemSettings: (state, payload) => (state.systemSettings = payload),
  },
  actions: {
    async fetchSystemSetting(ctx, key) {
      return $http('v2')
        .get(`system_settings/${key}`)
        .then((response) => {
          return response?.data?.data;
        });
    },

    async saveSystemSettingsAction({ commit }, { key, value }) {
      return $http('v2')
        .post(
          `system_settings`,
          {
            settings: {
              key,
              value,
            },
          },
          { notifiable: true }
        )
        .then(async (response) => {
          commit('setSystemSettings', response.data.data);
          return response;
        });
    },
  },
};
